import Breadcrumb from "../components/Breadcrumb";
import HeaderOne from "../components/HeaderOne";
import SignUpInner from "../components/SignUpInner";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const SignUpPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Sign Up"} />

      {/* SignUpInner */}
      <SignUpInner />
      
    </>
  );
};

export default SignUpPage;
